import {
  SIGNUP_ORGANIZATION,
  SIGNUP_ORGANIZATION_SUCCESS,
  SIGNUP_ORGANIZATION_ERROR,
  GET_ORGANIZATION,
  GET_ORGANIZATION_SUCCESS,
  GET_ORGANIZATION_ERROR,
  UPDATE_ORGANIZATION_ADDRESS,
  GET_IMAGE,
  GET_IMAGE_SUCCESS,
  GET_IMAGE_ERROR,
  UPLOAD_IMAGE,
  UPLOAD_IMAGE_SUCCESS,
  UPLOAD_IMAGE_ERROR,
} from '../actions';

/* Signup */
export const signupOrganization = (organization, history) => ({
  type: SIGNUP_ORGANIZATION,
  payload: { organization, history }
})
export const signupOrganizationSuccess = (organization) => ({
  type: SIGNUP_ORGANIZATION_SUCCESS,
  payload: organization
})
export const signupOrganizationError = (message) => ({
  type: SIGNUP_ORGANIZATION_ERROR,
  payload: { message }
})

/* GET */
export const getOrganization = (organization, history) => ({
  type: GET_ORGANIZATION,
  payload: { organization, history }
});
export const getOrganizationSuccess = (organization) => ({
  type: GET_ORGANIZATION_SUCCESS,
  payload: organization
});
export const getOrganizationError = (message) => ({
  type: GET_ORGANIZATION_ERROR,
  payload: { message }
});

export const updateOrganizationAddress = (organization, history) => ({
  type: UPDATE_ORGANIZATION_ADDRESS,
  payload: { organization, history }
});

/* IMAGE */
export const getImage = (history) => ({
  type: GET_IMAGE,
  payload: { history }
});
export const getImageSuccess = (image) => ({
  type: GET_IMAGE_SUCCESS,
  payload: image
});
export const getImageError = (message) => ({
  type: GET_IMAGE_ERROR,
  payload: { message }
});

export const uploadImage = (image, history) => ({
  type: UPLOAD_IMAGE,
  payload: { image, history }
});
export const uploadImageSuccess = (image) => ({
  type: UPLOAD_IMAGE_SUCCESS,
  payload: image
});
export const uploadImageError = (message) => ({
  type: UPLOAD_IMAGE_ERROR,
  payload: { message }
});